import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { COMPLETE_DEADLINE_SITUATIONS, RATINGS, RESPONSE_DEADLINE_SITUATIONS, STATUS } from '@consts';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { searchManyInputStyles } from '@core/components/fc-input/base/fc-search-many-input/fc-search-many-input.component';
import { Label, MaintenanceDeadlineStatusEnum, Problem, User, WarrantiesStatusEnum } from '@core/interfaces';
import { PaymentStatus } from '@core/interfaces/payments';
import { clearEmptyProperties, endOfDay, mapCheckbox, mapIds, parseBoolean, parseDate, parseIdsToBooleanArray, splitStringByComma, startOfDay } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { DateIntervalValidation } from '@validators/date-interval-validation';
import { DatePeriodValidation } from '@validators/date-period-validation';
import { DateValidation } from '@validators/date.validation';
import { cloneDeep, isEmpty } from 'lodash';
import moment from 'moment';
import { Subject } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import english from './../i18n/en.json';
import spanish from './../i18n/es.json';
import portuguese from './../i18n/pt.json';
import { MaintenanceFilterApi } from './services/maintenance-filter-api.service';
import { MaintenanceFilterState } from './services/maintenance-filter-state.service';
var FilterMaintenanceComponent = /** @class */ (function () {
    function FilterMaintenanceComponent(formBuilder, activatedRoute, translateService, maintenanceFilterApi, maintenanceFilterState, authenticationService, fuseTranslationLoaderService) {
        this.formBuilder = formBuilder;
        this.activatedRoute = activatedRoute;
        this.translateService = translateService;
        this.maintenanceFilterApi = maintenanceFilterApi;
        this.maintenanceFilterState = maintenanceFilterState;
        this.authenticationService = authenticationService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.changeView = new Subject();
        this.problems = [];
        this.assignees = [];
        this.requesters = [];
        this.companies = [];
        this.locationsGroups = [];
        this.maintenanceTypes = [];
        this.segments = [];
        this.labels = [];
        this.desiredStyle = searchManyInputStyles.Outlined;
        this.STATUS = STATUS;
        this.RATINGS = RATINGS;
        this.COMPLETE_DEADLINE_SITUATIONS = COMPLETE_DEADLINE_SITUATIONS;
        this.RESPONSE_DEADLINE_SITUATIONS = RESPONSE_DEADLINE_SITUATIONS;
        this.PAYMENT_STATUS = Object.values(PaymentStatus);
        this.maintenanceDeadlineStatusList = Object.keys(MaintenanceDeadlineStatusEnum);
        this.warrantyStatus = Object.keys(WarrantiesStatusEnum);
        this.hasLabelViewPermission = this.authenticationService.hasPermission('labels-list');
        this.hasLocationGroupsViewGroupPermission = this.authenticationService.hasPermission('locations-groups-list');
        this.hasFlagWarranties = this.authenticationService.hasFlags(['warranties']);
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FilterMaintenanceComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, queryParams, number_contains, archived, has_equipments, status_in, typeId_in, segmentId_in, locationId_in, locationGroupId_in, companyId_in, openedAt_gte, openedAt_lte, scheduledAt_gte, scheduledAt_lte, closedAt_gte, closedAt_lte, responsePeriod, solutionPeriod, _a, closeOnPeriodSituation, firstVisitOnPeriodSituation, mappedResponseStatus, mappedSolutionStatus, locationIds, locations, _b, companyIds, companies;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.maintenanceFilterApi.getFilterData()];
                    case 1:
                        data = _c.sent();
                        this.labels = data.labels;
                        this.problems = data.problems;
                        this.companies = data.companies;
                        this.assignees = data.assignees;
                        this.requesters = data.requesters;
                        this.locationsGroups = data.locationsGroups;
                        this.maintenanceTypes = data.maintenanceTypes;
                        this.segments = data.segments;
                        this.filtersForm = this.formBuilder.group({
                            number: null,
                            message: null,
                            openedAtLte: [moment(), [Validators.required, DateValidation.validate]],
                            openedAtGte: [moment().subtract(1, 'years'), [Validators.required, DateValidation.validate]],
                            closedAtGte: [null, DateValidation.validate],
                            closedAtLte: [null, DateValidation.validate],
                            scheduledAtGte: [null, DateValidation.validate],
                            scheduledAtLte: [null, DateValidation.validate],
                            hasEquipments: new FormControl(''),
                            archived: new FormControl(false),
                            assignees: new FormControl([]),
                            segmentId: new FormControl([]),
                            requesters: new FormControl([]),
                            companies: new FormControl([]),
                            equipmentId: new FormControl(),
                            locations: new FormControl([]),
                            status: new FormArray(STATUS.map(function () { return new FormControl(false); })),
                            ratings: new FormArray(RATINGS.map(function () { return new FormControl(false); })),
                            segments: new FormControl([]),
                            paymentStatus: new FormArray(this.PAYMENT_STATUS.map(function () { return new FormControl(false); })),
                            paymentNumber: new FormControl(''),
                            pendenciesTreatmentStatus: new FormControl(''),
                            pendenciesTypes: new FormControl(''),
                            pendenciesStatus: new FormControl(''),
                            firstVisitOnPeriodSituation: new FormArray(RESPONSE_DEADLINE_SITUATIONS.map(function () { return new FormControl(false); })),
                            closeOnPeriodSituation: new FormArray(COMPLETE_DEADLINE_SITUATIONS.map(function () { return new FormControl(false); })),
                            locationsGroups: new FormArray(this.locationsGroups.map(function () { return new FormControl(false); })),
                            maintenanceTypes: new FormArray(this.maintenanceTypes.map(function () { return new FormControl(false); })),
                            problems: new FormArray(this.problems.map(function () { return new FormControl(false); })),
                            labels: new FormArray(this.labels.map(function () { return new FormControl(false); })),
                            warrantyMaintenanceStatus: new FormControl(''),
                            warrantyStartDateLte: [null, DateValidation.validate],
                            warrantyEndDateGte: [null, DateValidation.validate],
                            warrantyStatusIn: new FormArray(this.warrantyStatus.map(function () { return new FormControl(false); })),
                        }, {
                            validators: [
                                DatePeriodValidation.validate(['openedAt', 'closedAt', 'scheduledAt']),
                                DateIntervalValidation.validate({
                                    from: 'openedAtGte',
                                    to: 'openedAtLte',
                                    maxDiffLte: 1,
                                    unit: 'year'
                                }),
                            ]
                        });
                        this.filtersForm.addControl('responseDeadlineStatus', new FormArray(this.maintenanceDeadlineStatusList.map(function () { return new FormControl(false); })));
                        this.filtersForm.addControl('solutionDeadlineStatus', new FormArray(this.maintenanceDeadlineStatusList.map(function () { return new FormControl(false); })));
                        this.maintenanceFilterState.onClearFilter.subscribe(function () {
                            _this.filtersForm.reset();
                            _this.filtersForm.get('archived').setValue(false);
                            _this.filtersForm.get('hasEquipments').setValue('');
                            _this.filtersForm.get('openedAtLte').setValue(moment());
                            _this.filtersForm.get('openedAtGte').setValue(moment().subtract(1, 'years'));
                        });
                        this.filtersForm.valueChanges
                            .pipe(debounceTime(400), filter(function () { return _this.filtersForm.valid; }))
                            .subscribe(function () {
                            var value = _this.filtersForm.getRawValue();
                            var openedAtGte = value.openedAtGte;
                            var openedAtLte = value.openedAtLte;
                            var closedAtGte = value.closedAtGte;
                            var closedAtLte = value.closedAtLte;
                            var scheduledAtGte = value.scheduledAtGte;
                            var scheduledAtLte = value.scheduledAtLte;
                            var warrantyStartDateGte = value.warrantyStartDateLte;
                            var warrantyEndDateLte = value.warrantyEndDateGte;
                            _this.maintenanceFilterState.query = {
                                number_contains: value.number,
                                companyId_in: mapIds(value.companies),
                                assigneeId_in: value.assignees,
                                message_contains: value.message,
                                equipmentId_in: value.equipmentId,
                                locationId_in: mapIds(value.locations),
                                requesterId_in: mapIds(value.requesters),
                                openedAt_gte: startOfDay(openedAtGte),
                                openedAt_lte: endOfDay(openedAtLte),
                                closedAt_gte: startOfDay(closedAtGte),
                                closedAt_lte: endOfDay(closedAtLte),
                                archived: value.archived,
                                has_equipments: value.hasEquipments,
                                scheduledAt_gte: startOfDay(scheduledAtGte, 'YYYY-MM-DD'),
                                scheduledAt_lte: endOfDay(scheduledAtLte, 'YYYY-MM-DD'),
                                status_in: mapCheckbox(value.status, _this.STATUS, 'name'),
                                typeId_in: mapCheckbox(value.maintenanceTypes, _this.maintenanceTypes, 'id'),
                                problemId_in: mapCheckbox(value.problems, _this.problems, 'id'),
                                labelId_in: mapCheckbox(value.labels, _this.labels, 'id'),
                                rating_in: mapCheckbox(value.ratings, _this.RATINGS, 'value'),
                                segmentId_in: mapIds(value.segments),
                                paymentStatus_in: mapCheckbox(value.paymentStatus, _this.PAYMENT_STATUS),
                                paymentNumber_contains: value.paymentNumber,
                                pendenciesTreatmentStatus_in: value.pendenciesTreatmentStatus,
                                pendenciesTypeId_in: mapIds(value.pendenciesTypes),
                                pendenciesStatus_in: value.pendenciesStatus,
                                locationsGroupsId_in: mapCheckbox(value.locationsGroups, _this.locationsGroups, 'id'),
                                firstVisitStartedOnPeriod: _this.getFirstVisitOnPeriodFilterValue(),
                                closedOnPeriod: _this.getCloseOnPeriodOnPeriodFilterValue(),
                                warrantyMaintenanceStatus: value.warrantyMaintenanceStatus,
                                warrantyStartDateLte: endOfDay(warrantyStartDateGte, 'YYYY-MM-DD'),
                                warrantyEndDateGte: startOfDay(warrantyEndDateLte, 'YYYY-MM-DD'),
                                warrantyStatusIn: mapCheckbox(value.warrantyStatusIn, _this.warrantyStatus),
                            };
                            _this.maintenanceFilterState.query.responseDeadlineStatus_in = mapCheckbox(value.responseDeadlineStatus, _this.maintenanceDeadlineStatusList);
                            _this.maintenanceFilterState.query.solutionDeadlineStatus_in = mapCheckbox(value.solutionDeadlineStatus, _this.maintenanceDeadlineStatusList);
                            _this.maintenanceFilterState.query = clearEmptyProperties(_this.maintenanceFilterState.query);
                            _this.maintenanceFilterState.onChangeFilter.next();
                        });
                        queryParams = cloneDeep(this.activatedRoute.snapshot.queryParams || {});
                        Reflect.deleteProperty(queryParams, 'id');
                        Reflect.deleteProperty(queryParams, 'selectedTab');
                        if (!!isEmpty(queryParams)) return [3 /*break*/, 5];
                        number_contains = queryParams.number_contains, archived = queryParams.archived, has_equipments = queryParams.has_equipments, status_in = queryParams.status_in, typeId_in = queryParams.typeId_in, segmentId_in = queryParams.segmentId_in, locationId_in = queryParams.locationId_in, locationGroupId_in = queryParams.locationGroupId_in, companyId_in = queryParams.companyId_in, openedAt_gte = queryParams.openedAt_gte, openedAt_lte = queryParams.openedAt_lte, scheduledAt_gte = queryParams.scheduledAt_gte, scheduledAt_lte = queryParams.scheduledAt_lte, closedAt_gte = queryParams.closedAt_gte, closedAt_lte = queryParams.closedAt_lte, responsePeriod = queryParams.responsePeriod, solutionPeriod = queryParams.solutionPeriod;
                        _a = this.getResponseAndSolutionQueryParam({ responsePeriod: responsePeriod, solutionPeriod: solutionPeriod }), closeOnPeriodSituation = _a.closeOnPeriodSituation, firstVisitOnPeriodSituation = _a.firstVisitOnPeriodSituation, mappedResponseStatus = _a.mappedResponseStatus, mappedSolutionStatus = _a.mappedSolutionStatus;
                        locationIds = splitStringByComma(locationId_in);
                        if (!locationIds.length) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.maintenanceFilterApi.findLocations(locationIds)];
                    case 2:
                        _b = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _b = [];
                        _c.label = 4;
                    case 4:
                        locations = _b;
                        companyIds = splitStringByComma(companyId_in);
                        companies = companyIds.length ? companyIds.map(function (id) { return ({ id: id }); }) : [];
                        this.filtersForm.reset();
                        this.filtersForm.patchValue({
                            number: number_contains || null,
                            archived: parseBoolean(archived),
                            hasEquipments: has_equipments,
                            status: parseIdsToBooleanArray(this.STATUS, status_in, 'name'),
                            maintenanceTypes: parseIdsToBooleanArray(this.maintenanceTypes, typeId_in, 'id'),
                            locations: locations || [],
                            locationsGroups: parseIdsToBooleanArray(this.locationsGroups, locationGroupId_in, 'id'),
                            companies: companies || [],
                            openedAtGte: parseDate(openedAt_gte),
                            openedAtLte: parseDate(openedAt_lte),
                            closedAtGte: parseDate(closedAt_gte),
                            closedAtLte: parseDate(closedAt_lte),
                            scheduledAtGte: parseDate(scheduledAt_gte),
                            scheduledAtLte: parseDate(scheduledAt_lte),
                            firstVisitOnPeriodSituation: firstVisitOnPeriodSituation,
                            closeOnPeriodSituation: closeOnPeriodSituation,
                            responseDeadlineStatus: mappedResponseStatus,
                            solutionDeadlineStatus: mappedSolutionStatus,
                        });
                        _c.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    FilterMaintenanceComponent.prototype.firstVisitOnPeriodOnChange = function (selectedIndex) {
        var firstVisitOnPeriodControls = this.filtersForm.controls['firstVisitOnPeriodSituation'];
        firstVisitOnPeriodControls.controls.forEach(function (control, controlIndex) {
            if (controlIndex !== selectedIndex) {
                control.setValue(false);
            }
        });
    };
    FilterMaintenanceComponent.prototype.closeOnPeriodOnChange = function (selectedIndex) {
        var closeOnPeriodControls = this.filtersForm.controls['closeOnPeriodSituation'];
        closeOnPeriodControls.controls.forEach(function (control, controlIndex) {
            if (controlIndex !== selectedIndex) {
                control.setValue(false);
            }
        });
    };
    FilterMaintenanceComponent.prototype.getFirstVisitOnPeriodFilterValue = function () {
        var firstVisitOnPeriod = this.filtersForm.controls['firstVisitOnPeriodSituation'];
        var selectedIndex = null;
        for (var index = 0; index < firstVisitOnPeriod.value.length; index++) {
            var value = firstVisitOnPeriod.value[index];
            if (value) {
                selectedIndex = index;
                break;
            }
        }
        if (selectedIndex === null) {
            return undefined;
        }
        return RESPONSE_DEADLINE_SITUATIONS[selectedIndex].value;
    };
    FilterMaintenanceComponent.prototype.getLabelName = function (label, index) {
        if (index === 0) {
            return this.translateService.instant('MAINTENANCES.FILTERS.NO_LABELS');
        }
        else {
            return label.name;
        }
    };
    FilterMaintenanceComponent.prototype.getCloseOnPeriodOnPeriodFilterValue = function () {
        var closeOnPeriodControl = this.filtersForm.controls['closeOnPeriodSituation'];
        var selectedIndex = null;
        for (var index = 0; index < closeOnPeriodControl.value.length; index++) {
            var value = closeOnPeriodControl.value[index];
            if (value) {
                selectedIndex = index;
                break;
            }
        }
        if (selectedIndex === null) {
            return undefined;
        }
        return COMPLETE_DEADLINE_SITUATIONS[selectedIndex].value;
    };
    FilterMaintenanceComponent.prototype.getPropertyValue = function (value, array, property) {
        var item = array.find(function (a) { return a.id === value; });
        return item[property];
    };
    FilterMaintenanceComponent.prototype.getResponseAndSolutionQueryParam = function (_a) {
        var responsePeriod = _a.responsePeriod, solutionPeriod = _a.solutionPeriod;
        var firstVisitOnPeriodSituation = [null, null];
        var closeOnPeriodSituation = [null, null];
        var responseDeadlineStatus = [];
        var solutionDeadlineStatus = [];
        if (responsePeriod === 'on') {
            firstVisitOnPeriodSituation[0] = true;
            responseDeadlineStatus.push('completedOnTime', 'atRisk', 'withinDeadline');
        }
        if (responsePeriod === 'out') {
            firstVisitOnPeriodSituation[1] = true;
            responseDeadlineStatus.push('violated', 'completedWithViolation');
        }
        if (solutionPeriod === 'on') {
            closeOnPeriodSituation[0] = true;
            solutionDeadlineStatus.push('completedOnTime', 'atRisk', 'withinDeadline');
        }
        if (solutionPeriod === 'out') {
            closeOnPeriodSituation[1] = true;
            solutionDeadlineStatus.push('violated', 'completedWithViolation');
        }
        if (responsePeriod === 'notApplied' || solutionPeriod === 'notApplied') {
            firstVisitOnPeriodSituation[0] = true;
            firstVisitOnPeriodSituation[1] = true;
            solutionDeadlineStatus.push('notApplied');
            responseDeadlineStatus.push('notApplied');
        }
        var mappedSolutionStatus = this.maintenanceDeadlineStatusList.map(function (status) { return solutionDeadlineStatus.includes(status); });
        var mappedResponseStatus = this.maintenanceDeadlineStatusList.map(function (status) { return responseDeadlineStatus.includes(status); });
        return { firstVisitOnPeriodSituation: firstVisitOnPeriodSituation, closeOnPeriodSituation: closeOnPeriodSituation, mappedSolutionStatus: mappedSolutionStatus, mappedResponseStatus: mappedResponseStatus };
    };
    return FilterMaintenanceComponent;
}());
export { FilterMaintenanceComponent };
